import { render } from "./CacheControl.vue?vue&type=template&id=46cc9753"
import script from "./CacheControl.vue?vue&type=script&lang=js"
export * from "./CacheControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__